import helpers from "@/common/utils/helpers";
let meses =  [];
export default {
    setInicio(dataInicio, numeroMes){
        meses = helpers.criarArrayMes(dataInicio, 60, !numeroMes)
    },
    previsao : [
        { key : "tipo",  label : "Tipo", 
            formatter : (value) => {
                return helpers.getEnum(value) ? helpers.getEnum(value).text : value;
            }
        },
        { key : "detalhamento",  label : "Detalhamento" },
        { key : "justificativa",  label : "Justificativa" },
        { key : "mes",  label : "Mês", 
            formatter : (a,b,c) => {
                if(c.tipo == -1) return "";
                return meses.find(el => el.value === c.mes) ? meses.find(el => el.value === c.mes).text : c.mes;
            }
        },
        { key : "valor",  label : "Valor",
            formatter : (value) => helpers.formatarValor(value)
        },
        { key : "actions",  label : "Ações" },
    ],
}